
function lpcParseMeasure(value) {
  const match=value.trim().match(/^(\d{1,2}(?:[.,]\d{1,2})?)\s*(?:cm)?(?:\s*(?:à|[-–—])\s*(\d{1,2}(?:[.,]\d{1,2})?)\s*(?:cm)?)?$/i);
  if(!match) return null;
  const min=Number(match[1].replace(',','.'));
  const max=match[2]?Number(match[2].replace(',','.')):min;
  return min>0&&max>=min?{min,max,range:!!match[2]}:null;
}
function lpcFindSize(cm, rows) {
  if(!rows.length||rows.some(row=>!row.measure))return {state:'missing'};
  const sorted=[...rows].sort((a,b)=>a.measure.max-b.measure.max);
  if(cm<sorted[0].measure.min||cm>sorted[sorted.length-1].measure.max)return {state:'outside'};
  const exact=sorted.find(row=>cm>=row.measure.min&&cm<=row.measure.max);
  if(exact)return {state:'match',row:exact};
  const lower=sorted.filter(row=>row.measure.max<cm).pop();
  const upper=sorted.find(row=>row.measure.min>cm);
  const midpoint=(lower.measure.max+upper.measure.min)/2;
  return {state:'between',lower,upper,row:cm<midpoint-1e-9?lower:upper};
}
if(!customElements.get('lpc-size-finder')){
 customElements.define('lpc-size-finder',class extends HTMLElement{
  connectedCallback(){
   if(this.initialized)return;
   this.input=this.querySelector('[data-measure]');
   this.result=this.querySelector('[data-result]');
   if(!this.input||!this.result)return;
   this.initialized=true;
   this.querySelector('[data-calculate]').addEventListener('click',()=>this.calculate());
   this.input.addEventListener('keydown',event=>{if(event.key==='Enter'){event.preventDefault();this.calculate();}});
   this.input.addEventListener('input',()=>{this.result.hidden=true;this.input.removeAttribute('aria-invalid');this.clearRows();});
  }
  clearRows(){this.querySelectorAll('tbody tr').forEach(row=>row.removeAttribute('data-selected'));}
  calculate(){
   this.clearRows();this.result.replaceChildren();this.result.hidden=false;
   const raw=this.input.value.trim(),cm=Number(raw.replace(',','.'));
   if(!/^\d{1,2}(?:[.,]\d{1,2})?$/.test(raw)||!Number.isFinite(cm)||cm<=0){
    this.input.setAttribute('aria-invalid','true');this.result.textContent='Indiquez une longueur valide en cm, par exemple 24 ou 23,5.';this.input.focus();return;
   }
   this.input.removeAttribute('aria-invalid');
   const rows=[...this.querySelectorAll('tbody tr')].map(element=>({element,size:element.querySelector('th').textContent.trim(),measure:lpcParseMeasure(element.querySelector('td').textContent)}));
   const outcome=lpcFindSize(cm,rows);
   if(outcome.state==='missing'){this.result.textContent='Les mesures de ce modèle ne sont pas encore confirmées. Contactez-nous avec la longueur du pied pour vérifier la pointure.';return;}
   if(this.dataset.measureKind==='inner'){this.result.textContent='Ce tableau indique la longueur intérieure du chausson, pas celle du pied. Contactez-nous avec votre mesure de '+cm.toLocaleString('fr-FR')+' cm pour confirmer la pointure et l’espace nécessaire pour les orteils.';return;}
   if(outcome.state==='outside'){this.result.textContent='Votre mesure est hors des longueurs indiquées pour '+this.dataset.model+'. Contactez-nous pour vérifier la pointure adaptée.';return;}
   const row=outcome.row;
   let sizeOption;
   try{sizeOption=JSON.parse(this.dataset.options||'[]').find(option=>/pointure|taille|size/i.test(option.name));}catch{}
   const normalize=value=>String(value).replace(/\s/g,'').replace(/[–—/]/g,'-');
   if(sizeOption&&!sizeOption.values.some(value=>normalize(typeof value==='object'?value.name:value)===normalize(row.size))){
    this.result.textContent='Le tableau correspond à la pointure '+row.size+', mais cette taille n’est pas proposée sur cette fiche. Contactez-nous pour une alternative.';return;
   }
   const title=document.createElement('strong');title.textContent=this.dataset.estimated==='true'?'Pointure estimée : '+row.size:(outcome.state==='between'?'Pointure conseillée : ':'Pointure correspondante : ')+row.size;this.result.append(title);
   const detail=document.createElement('p');detail.textContent=outcome.state==='between'?'Avec '+cm.toLocaleString('fr-FR')+' cm, vous êtes entre les pointures '+outcome.lower.size+' et '+outcome.upper.size+'. Nous vous conseillons le '+row.size+', la pointure la plus proche de votre mesure. En cas d’égalité, nous privilégions la plus grande.':'Pour un pied de '+cm.toLocaleString('fr-FR')+' cm, selon le tableau '+this.dataset.model+'.';if(this.dataset.estimated==='true')detail.textContent+=' Estimation issue du guide général, à confirmer pour ce modèle.';this.result.append(detail);
   row.element.setAttribute('data-selected','');
  }
 });
}
